import { useCallback, useSyncExternalStore } from 'react';
import { useContext } from '../context';
import type { Appearance } from '../context/types';
import type { Config } from '../createConfig';
import { deepEqual } from '../utils/deepEqual';

export type UseAppearanceReturnType = {
  appearance: Appearance;
  setAppearance: (value?: Appearance) => void;
};

export type WatchAppearanceParameters = {
  onChange(appearance: Appearance, prevAppearance: Appearance): void;
};

let previousAppearance: Appearance = {};

export function getAppearance(config: Config) {
  const appearance = { ...config.appearanceStore.getState() };
  if (deepEqual(previousAppearance, appearance)) return previousAppearance;

  previousAppearance = appearance;
  return appearance;
}

export function useAppearance(config?: Config): UseAppearanceReturnType {
  if (!config) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { config: globalConfig } = useContext();
    config = globalConfig;
  }

  const setAppearance = useCallback(
    (value?: Appearance) => {
      config.appearanceStore.setState(value || {}, true);
    },
    [config.appearanceStore]
  );

  const appearance = useSyncExternalStore(
    config.appearanceStore.subscribe,
    () => getAppearance(config),
    () => getAppearance(config)
  );

  return {
    appearance,
    setAppearance,
  };
}
